// @flow
import React from 'react';
import type { Children } from 'react';
import styled from 'styled-components';

import { colors } from '../../shared/styles';

const StyledButton = styled.button`
    background: ${colors.orange.default};
    color: ${colors.white};
    border: none;
    border-radius: 4px;
    text-align: center;
    text-decoration: none;
    padding: 12px 24px;
    font-size: 14px;
    white-space: nowrap;
    cursor: pointer;

    &[disabled] {
        background: ${colors.offWhite};
        color: ${colors.grey.light};
        cursor: not-allowed;
    }
`;

type ButtonProps = {
    children?: Children,
    disabled?: boolean,
    type?: string,
    onClick?: Function,
};

const dummyOnClick = () => {};

const Button = (props: ButtonProps) => {
    const { children, disabled, type, onClick } = props;

    const actualOnClick = onClick || dummyOnClick;

    return (
        <StyledButton
            type={type || 'button'}
            onClick={actualOnClick}
            disabled={disabled}
        >
            {children}
        </StyledButton>
    );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/Button.js